export const reportGroups = [
	{
		key: 'outstandingBalances',
		title: 'Outstanding Balances',
		reports: [
			{
				key: 'outstandingBalance',
				title: 'Outstanding Balance Report',
				isAvailable: false,
			},
			{
				key: 'outstandingBalanceSummary',
				title: 'Outstanding Balance Summary Report',
				isAvailable: false,
			},
		],
	},
	{
		key: 'invoices',
		title: 'Invoices',
		reports: [
			{
				key: 'invoice',
				title: 'Invoice Report',
				isAvailable: false,
			},
			{
				key: 'invoiceMonthlyDetail',
				title: 'Invoice Monthly Detail Report',
				isAvailable: true,
			},
			{
				key: 'validationAndOtherDetail',
				title: 'Validation & Other Detail Report',
				isAvailable: false,
			},
			{
				key: 'invoiceAdjustment',
				title: 'Adjustment Report',
				isAvailable: false,
			},
		],
	},
	{
		key: 'payments',
		title: 'Payments',
		reports: [
			{
				key: 'paymentSummary',
				title: 'Payment Summary Report',
				isAvailable: true,
			},
			{
				key: 'monthlyParkingPayment',
				title: 'Monthly Parking Payment Report',
				isAvailable: true,
			},
			{
				key: 'paymentReconciliation',
				title: 'Payment Reconciliation Report',
				isAvailable: false,
			},
			{
				key: 'cashBasisPayment',
				title: 'Cash Basis Payment Report',
				isAvailable: false,
			},
		],
	},
	{
		key: 'dailyReports',
		title: 'Daily Reports',
		reports: [
			{
				key: 'dailyRevenue',
				title: 'Daily Revenue Report',
				isAvailable: false,
			},
			{
				key: 'missingDailyRevenue',
				title: 'Missing DR Report',
				isAvailable: false,
			},
		],
	},
	{
		key: 'otherReports',
		title: 'Other Reports',
		reports: [
			{
				key: 'transaction',
				title: 'Transaction Report',
				isAvailable: true,
			},
			{
				key: 'signUpTermination',
				title: 'Sign Up / Termination Report',
				isAvailable: false,
			},
			{
				key: 'subscriptionActivity',
				title: 'Subscription Activity Report',
				isAvailable: false,
			},
			{
				key: 'facilitySettings',
				title: 'Facility Settings Report',
				isAvailable: false,
			},
			{
				key: 'previewAutoInvoice',
				title: 'Preview Auto Invoice Report',
				isAvailable: false,
			},
			{
				key: 'leaseManagerAllocation',
				title: 'Lease Manager Allocation Report',
				isAvailable: false,
			},
		],
	},
] as const;

export type ReportGroup = (typeof reportGroups)[number];
export type ReportGroupKey = ReportGroup['key'];

export type ReportCatalogEntry = ReportGroup['reports'][number];
export type ReportCatalogKey = ReportCatalogEntry['key'];

export type AvailableReport = Extract<ReportCatalogEntry, { isAvailable: true }>;

export type ReportType = AvailableReport['key'];
